

/// <reference path="StockNote.ts" />

// Generated class CustomOutputNote_ManagedObject

class CustomOutputNote_ManagedObject extends StockNote
{
}
